import React from 'react';
import { AccountType } from 'types/userTypes';
import { classNames } from 'utils/classUtils';

type AccountFields = keyof AccountType;

interface ErrorMsg {
  message: string;
}

export type AccountFormFieldError = {
  [field in AccountFields]?: ErrorMsg;
};

interface AccountFormFieldProps {
  id: string;
  label?: string;
  fieldErrors: AccountFormFieldError;
  children: JSX.Element;
}

export const AccountFormField = ({
  id,
  label,
  fieldErrors,
  children,
}: AccountFormFieldProps): JSX.Element => (
  <div
    className={classNames(
      { 'has-error': !!fieldErrors[id] },
      'edit-account-modal__form-group'
    )}
  >
    <label>
      {label && <span className="edit-account-modal__form-label">{label}</span>}
      {children}
    </label>
    {fieldErrors[id] && <em>{fieldErrors[id].message}</em>}
  </div>
);
